import { createResource } from 'react-resource-router';
import { assert, AssertionError } from '@atlassian/eoc-common';
import { getSidebarRightsEndpoint, getTeamByIdEndpoint } from '../endpoints';
export const teamResource = createResource({
  type: 'teamResource',
  getKey: routerContext => {
    var _routerContext$match$;
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    return `team-dashboard/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$2;
    const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
    assert(!!teamId, new AssertionError('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
    return getTeamByIdEndpoint(teamId);
  },
  maxAge: 300000,
  // refresh it after 5 minutes
  isBrowserOnly: true
});
export const sidebarRightsResource = createResource({
  type: 'sidebarRightsResource',
  getKey: routerContext => {
    var _routerContext$match$3;
    const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
    return `team-dashboard/${teamId !== null && teamId !== void 0 ? teamId : ''}/sidebar-rights`;
  },
  getData: async routerContext => {
    var _routerContext$match$4;
    const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
    assert(!!teamId, new AssertionError('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
    return getSidebarRightsEndpoint(teamId);
  },
  isBrowserOnly: true,
  maxAge: Infinity
});
export const resources = [teamResource, sidebarRightsResource];